if (!customElements.get('bundle-product-form')) {
  customElements.define('bundle-product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.selectButton = this.querySelector('[name="select"]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.selectedProducts = [];

      document.addEventListener("BundleQuantityChange", (e) => {
        this.selectedProducts[e.detail.variantid] = e.detail.quantity;
        if (e.detail.quantity <= 0) {
          delete this.selectedProducts[e.detail.variantid];
        }
        const selectedProductsLength = Object.keys(this.selectedProducts).length;
        if (selectedProductsLength > 0) {
          this.selectButton.classList.add("hidden");
          this.submitButton.classList.remove("hidden");
        } else {
          this.selectButton.classList.remove("hidden");
          this.submitButton.classList.add("hidden");
        }
      });

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = "application/json";

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      let showErrorMessage = false;

      let uniqueProducts = this.selectedProducts;   

      let bundleProducts = {
        items: Object.entries(uniqueProducts).map(([key, value]) => {
          return {
              id: key,
              quantity: value
          }
        })
      };

      // Agregando propiedades nativas de shopify a bundle products
      for (const pair of formData.entries()) {
          if (pair[0] == 'id' || pair[0] == 'quantity') continue;
          bundleProducts[pair[0]] = pair[1]
      }

      config.body = JSON.stringify(bundleProducts);
      if (showErrorMessage == false) {
          fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
              if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
              } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
              }

              if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
              } else {
              this.cart.renderContents(response);
              }
          })
          .catch((e) => {
              console.error(e);
          })
          .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      } else {
          this.querySelector(".product-form__error-message-wrapper").removeAttribute("hidden");
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
      }
    }

  });
}


class QuantityInputBundle extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.price = this.dataset.price;
    this.variantId = this.dataset.id;
    this.changeEvent = new Event('change', { bubbles: true });
    this.parentRow = this.closest("tr");
    this.priceContainer = document.querySelector(".product__bundle-price .price");

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();

    if (this.input.value > 0) {
      this.parentRow.classList.add("active");
    } else {
      this.parentRow.classList.remove("active");
    }

    let totalPrice = 0;
    document.querySelectorAll(".bundle-product__variant.active").forEach( variant => {
      let inputQuantity = parseInt(variant.querySelector("quantity-input-bundle input").value);
      let inputPrice = parseFloat(variant.querySelector("quantity-input-bundle").dataset.price.replace(',', '.'));
      totalPrice = totalPrice + inputQuantity * inputPrice;
    });

    this.priceContainer.textContent = totalPrice.toFixed(2).replace(".", ",");
    
    const updateEvent = new CustomEvent("BundleQuantityChange", {
      detail: {
        variantid: this.variantId,
        quantity: this.input.value
      }
    });
    document.dispatchEvent(updateEvent);
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
      if (parseInt(this.input.value) > parseInt(this.input.max)) this.input.value = this.input.max;
    }
  }
}

customElements.define('quantity-input-bundle', QuantityInputBundle);